import { privateInstance } from "../configs";
import { mappers } from "@/mappers";

export const recipeProductApi = {
  async getRecipeProducts() {
    let url = `/recipes/api/product/list/?deleted=True`;
    const res = await privateInstance.get(url);
    return res.data.map(x => mappers.mapProduct(x));
  },
  async postRecipeProduct(product) {
    const res = await privateInstance.post(
      `/recipes/api/product/list/`,
      product
    );
    return mappers.mapProduct(res.data);
  },
  async retrieveRecipeProduct(id) {
    const res = await privateInstance.get(`/recipes/api/product/${id}/`);
    return mappers.mapProduct(res.data);
  },
  async putRecipeProduct(id, product) {
    const res = await privateInstance.put(
      `/recipes/api/product/${id}/`,
      product
    );
    return mappers.mapProduct(res.data);
  },
  async patchRecipeProduct(id, product) {
    const res = await privateInstance.patch(
      `/recipes/api/product/${id}/`,
      product
    );
    return mappers.mapProduct(res.data);
  },
  async patchSimpleRecipeProduct(id, product) {
    const res = await privateInstance.patch(
      `/recipes/api/product/update/${id}/`,
      product
    );
    return res.data;
  },
  async deleteRecipeProduct(id) {
    const res = await privateInstance.delete(`/recipes/api/product/${id}/`);
    return res.data;
  },
  async postRecipeProductLocalisation(localisation) {
    const res = await privateInstance.post(
      `/recipes/api/product/localisation/list/`,
      localisation
    );
    return res.data;
  },
  async putRecipeProductLocalisation(id, localisation) {
    const res = await privateInstance.put(
      `recipes/api/product/localisation/${id}/`,
      localisation
    );
    return res.data;
  },
  async postRecipeProductSupplier(supplier) {
    const res = await privateInstance.post(
      `/recipes/api/product/supplier/list/`,
      supplier
    );
    return res.data;
  },
  async putRecipeProductSupplier(id, supplier) {
    const res = await privateInstance.put(
      `recipes/api/product/supplier/${id}/`,
      supplier
    );
    return res.data;
  },
  async getRecipeProductOrderQuantities(productId, templateId) {
    let req = `/recipes/api/product/order-quantity/list/`;

    if (productId || templateId) {
      req += "?";
      if (productId) req += `product=${productId}`;
      if (templateId) req += `template=${templateId}`;
      req += "/";
    }

    const res = await privateInstance.get(req);
    return res.data;
  },
  async postRecipeProductOrderQuantity(orderQuantity) {
    const res = await privateInstance.post(
      `/recipes/api/product/order-quantity/list/`,
      orderQuantity
    );
    return res.data;
  },
  async putRecipeProductOrderQuantity(id, orderQuantity) {
    const res = await privateInstance.put(
      `recipes/api/product/order-quantity/${id}/`,
      orderQuantity
    );
    return res.data;
  },
  async postRecipeProductStoreTags(tags) {
    const res = await privateInstance.post(
      `/recipes/api/product/tags/list/`,
      tags
    );
    return res.data;
  },
  async putRecipeProductStoreTags(id, tags) {
    const res = await privateInstance.put(
      `recipes/api/product/tags/${id}/`,
      tags
    );
    return res.data;
  },
  async patchProductTags(id, data) {
    const res = await privateInstance.patch(
      `/recipes/api/product/tags/update/${id}/`,
      data
    );
    return res.data;
  },
  async getRecipeProductStoreTags(productId) {
    let req = `/recipes/api/product/tags/list/`;

    if (productId) req += `?product=${productId}/`;

    const res = await privateInstance.get(req);
    return res.data;
  },
  async importProductStoreData(params) {
    let req = `/recipes/api/product/import-data/`;

    if (params) {
      req += "?";
      let params_array = [];
      if (params.store) params_array.push(`store=${params.store}`);
      if (params.recipe) params_array.push(`recipe=${params.recipe}`);
      req += params_array.join("&");
    }

    const res = await privateInstance.get(req);
    return res.data;
  },
  async overwriteProductStoreData(params) {
    let req = `/recipes/api/debug/product/overwrite/`;

    if (params) {
      req += "?";
      let params_array = [];
      if (params.store) params_array.push(`store=${params.store}`);
      req += params_array.join("&");
    }

    const res = await privateInstance.get(req);
    return res.data;
  },
  async copyProductStoreDataFromProduct(store, product, params) {
    let req = `/recipes/api/product/get-data/?store=${store}&product=${product}`;

    if (params) {
      req += "&";
      let params_array = [];
      if (params.price) params_array.push(`price=${params.price}`);
      if (params.conversion) params_array.push(`tags=${params.conversion}`);
      if (params.tags) params_array.push(`tags=${params.tags}`);
      if (params.allergens) params_array.push(`allergens=${params.allergens}`);
      req += params_array.join("&");
    }

    const res = await privateInstance.get(req);
    return res.data;
  }
};
